import { createStore } from "vuex";
import actions from "../store/actions";
import mutations from "./mutations";
import CategoryService from "../../shared/services/CategoryService";
import { find, propEq, pathOr } from "ramda";
import ProductService from "../../shared/services/ProductService";
import CartService from "../../shared/services/CartService";

export default createStore({
    state: {
        category: null,
        products: null,
        loading: false,
        error: null,
        pageNumber: 1,
        filterState: null,
        filteredProducts: null,
        page: null,
        productSummary: null,
    },
    getters: {
        totalPages: (state) => {
            if (!state.page) {
                return 0;
            }
            return Math.ceil(state.page.TotalItems / state.page.PageSize);
        },
        pageNumber: (state) => {
            return state.pageNumber;
        },
        productSummary: (state) => {
            return state.productSummary || {};
        },
        maximumDevicePrice: (state) => {
            return state.productSummary.MaxPrice;
        },
        allBrands: (state) => {
            return state.productSummary.Brands;
        },
        allCategories: (state) => {
            return state.productSummary.Categories;
        },
    },
    mutations: {
        [mutations.SET_LOADING](state, loading) {
            state.loading = loading;
        },
        [mutations.SET_ERROR](state, error) {
            state.error = error;
        },
        [mutations.SET_CATEGORY](state, category) {
            state.category = category;
        },
        [mutations.SET_PAGE](state, page) {
            state.page = page;
        },
        [mutations.PRODUCT_SUMMARY](state, productSummary) {
            state.productSummary = productSummary;
        },
        [mutations.SET_PRODUCTS](state, products) {
            if (!products) {
                products = [];
            }
            state.products = products.sort((p) => p.Name);
        },
        [mutations.UPDATE_PAGE_NUMBER](state, pageNumber) {
            state.pageNumber = pageNumber;
        },
        [mutations.SET_FILTERED_PRODUCTS](state, payload) {
            let { filteredProducts, filterState } = { ...payload };
            if (!filterState) {
                filterState = { selectedBrands: [], selectedCategories: [] };
            }

            state.filteredProducts = filteredProducts.sort((p) => p.Name);
            state.filterState = filterState;
        },
    },
    actions: {
        [actions.GET_CATEGORY]({ dispatch, commit }) {
            commit(mutations.SET_LOADING, true);
            return CategoryService.getCategory()
                .then((data) => {
                    const deviceCategoryFinder = find(
                        propEq("Name", "Devices")
                    );
                    const deviceCategory = deviceCategoryFinder(data);
                    commit(mutations.SET_CATEGORY, deviceCategory);
                    commit(mutations.SET_LOADING, false);
                    dispatch(actions.PRODUCT_SUMMARY);
                })
                .catch((error) => {
                    commit(mutations.SET_ERROR, error.data.Message);
                    commit(mutations.SET_LOADING, false);
                });
        },
        [actions.GOTO_SHOPPING_CART]() {
            window.location.href = "\\cart"; //TODO: navigate to a controller. Check if there are only device products on the cart before navigating.
        },
        [actions.GET_PRODUCTS]({ state, commit }) {
            if (state.category) {
                commit(mutations.SET_LOADING, true);
                commit(mutations.SET_PRODUCTS, null);
                const params = {
                    categoryId: state.category.Id,
                    pageSize: 12,
                    page: state.pageNumber - 1,
                    ...(state.filterState || {}),
                };
                return ProductService.getPage(params)
                    .then((page) => {
                        commit(mutations.SET_PAGE, page);
                        commit(mutations.SET_PRODUCTS, page.Items);
                        commit(mutations.SET_LOADING, false);
                    })
                    .catch((error) => {
                        commit(mutations.SET_ERROR, error);
                        commit(mutations.SET_LOADING, false);
                    });
            }
        },
        [actions.PRODUCT_SUMMARY]({ state, commit }) {
            if (state.category) {
                return ProductService.getProductsSummary(state.category.Id)
                    .then((summary) =>
                        commit(mutations.PRODUCT_SUMMARY, summary)
                    )
                    .catch((error) => commit(mutations.SET_ERROR, error));
            }
        },
        [actions.UPDATE_PAGE_NUMBER]({ dispatch, commit }, pageNumber) {
            commit(mutations.UPDATE_PAGE_NUMBER, pageNumber);
            dispatch(actions.GET_PRODUCTS);
        },
        [actions.UPDATE_SELECTED_COLOR]({ state }, { product, colorName }) {
            const targetProduct = state.products.find(
                (f) => product && f.Id == product.Id
            );
            if (targetProduct) {
                targetProduct.SelectedColorName = colorName;
                targetProduct.StockLevels = pathOr(
                    0,
                    ["AttributeStockLevels", "Color", colorName, "Quantity"],
                    targetProduct
                );
            }
        },
        [actions.SELECT_DEVICE]({ commit }, product) {
            const payload = {
                productId: product.Id,
                productAttributes: { Color: product.SelectedColorName },
            };

            commit(mutations.SET_LOADING, true);
            return CartService.purchaseDevice(payload)
                .then((data) => (window.location.href = data.RedirectUrl))
                .catch((error) => {
                    commit(mutations.SET_ERROR, error.data.Value);
                    commit(mutations.SET_LOADING, false);
                    if (error.data.RedirectUrl) {
                        window.location.href = error.data.RedirectUrl;
                    }
                });
        },
        [actions.SET_FILTERED_PRODUCTS](
            { dispatch, commit },
            filteredProducts
        ) {
            commit(mutations.SET_FILTERED_PRODUCTS, filteredProducts);
            commit(mutations.UPDATE_PAGE_NUMBER, 1);
            dispatch(actions.GET_PRODUCTS);
        },
    },
    modules: {},
});
